import composeRichText from '@/client/services/richText/composeRichText'

export const DATA_CONSENT_INPUT_NAME = 'data-consent'
export const PROGRAM_STRUCTURE_CONSENT_INPUT_NAME = 'program-structure-consent'
export const ACKNOWLEDGEMENTS_INPUT_NAMES = [
  DATA_CONSENT_INPUT_NAME,
  PROGRAM_STRUCTURE_CONSENT_INPUT_NAME,
]

export type LearningLabsConsentDetails = {
  acknowledgements: (typeof ACKNOWLEDGEMENTS_INPUT_NAMES)[number][]
}

export const ALGEBRA2_FINALS_PREP_PROGRAM_STRUCTURE_CONSENT_TEXT = composeRichText(ctx => [
  ctx.paragraph(ctx.text('Program Schedule', { bold: true })),

  ctx.bulletedList(
    ctx.listItem(
      ctx.text('Week 1: ', { bold: true }),
      'There is only one session this week which we will use to identify your targeted focus areas to work on throughout the program to help you prepare effectively for your final exam.'
    ),
    ctx.listItem(
      ctx.text('Weeks 2 - 4: ', { bold: true }),
      'You will join two small group sessions each week. You and your peers will explore key concepts together and work on individual practice problems from your personalized learning plan.'
    )
  ),
])
